import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const ChatFAQIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "ChatFAQGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="white"
      strokeWidth="2"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      {/* <path
        d="M12 22.752V22.7522L12.0119 22.7517L12.0924 22.7478C12.1199 22.7508 12.1465 22.752 12.1719 22.752H20.8457C21.1504 22.752 21.425 22.5674 21.5401 22.2853C21.655 22.0035 21.5885 21.6798 21.3708 21.4664L19.4214 19.5564C21.2273 17.6567 22.25 15.1282 22.25 12.502C22.25 6.84972 17.6522 2.25195 12 2.25195C6.34776 2.25195 1.75 6.84972 1.75 12.502C1.75 18.1542 6.34777 22.752 12 22.752ZM12.1899 21.2442L12.1719 21.2426L12.1538 21.2435L11.9935 21.252C7.17212 21.2484 3.24999 17.3241 3.24999 12.502C3.24999 7.67762 7.17567 3.75195 12 3.75195C16.8243 3.75195 20.75 7.67762 20.75 12.502C20.75 14.9676 19.6921 17.3353 17.8464 18.9978C17.6926 19.1362 17.6026 19.3324 17.5982 19.5396C17.5938 19.7461 17.675 19.9462 17.8235 20.0911C17.8235 20.0911 17.8235 20.0911 17.8235 20.0911L19.0082 21.252H12.2884C12.2669 21.249 12.248 21.2477 12.234 21.2469C12.2254 21.2464 12.2189 21.246 12.2136 21.2458C12.2042 21.2453 12.1983 21.245 12.1899 21.2442Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
        strokeWidth="0.5"
      /> */}
      <path stroke="none" d="M0 0h24v24H0z" />
      <path d="M3 20l1.3 -3.9c-2.324 -3.437 -1.426 -7.872 2.1 -10.374c3.526 -2.501 8.59 -2.296 11.845 .48c3.255 2.777 3.695 7.266 1.029 10.501c-2.666 3.235 -7.615 4.215 -11.574 2.293l-4.7 1" />
    </svg>
  );
};

export default ChatFAQIcon;
